import { render } from "./ChildRiskSummary.vue?vue&type=template&id=3da09397&scoped=true"
import script from "./ChildRiskSummary.vue?vue&type=script&lang=js"
export * from "./ChildRiskSummary.vue?vue&type=script&lang=js"

import "./ChildRiskSummary.vue?vue&type=style&index=0&id=3da09397&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\tafe-raap-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da09397"]])

export default __exports__